import React, { useState, useEffect } from 'react'
import styles from './footer.module.scss'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { RootState } from '../../redux/store'
import { Words } from '../../types/lang'
// import { verifyUser } from '../../redux/userReducer/userReducer'

interface FooterProps {
  words: Words
  // verifyUser
  isUserVerified: boolean
}

const Footer = ({
  words,
  // verifyUser,
  isUserVerified = false,
}: FooterProps) => {
  useEffect(() => {
    // verifyUser()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.footerContainer}>
        <div className={styles.footerTopContainer}>
          <div className={styles.footerTop}>
            <div className={styles.centre}>
              <a href="https://facebook.com" target="_blank">
                <i
                  className={`${styles.icon} ${styles.facebook} fab fa-facebook`}
                ></i>
              </a>
              <a href="https://instagram.com" target="_blank">
                <i
                  className={`${styles.icon} ${styles.instagram} fab fa-instagram`}
                ></i>
              </a>
              <a href="https://youtube.com" target="_blank">
                <i
                  className={`${styles.icon} ${styles.youtube} fab fa-youtube`}
                ></i>
              </a>
              <a href="https://pinterest.com" target="_blank">
                <i
                  className={`${styles.icon} ${styles.pinterest} fab fa-pinterest-p`}
                ></i>
              </a>
              <a href="https://play.google.com" target="_blank">
                <i
                  className={`${styles.icon} ${styles.play} fab fa-google-play`}
                ></i>
              </a>
            </div>
          </div>
        </div>

        <div className={styles.footerMain}>
          <div className={styles.row}>
            <div className={styles.column}>
              <div className={styles.item}>{words.acc}</div>
              <NavLink
                to={`${isUserVerified ? '/my_account' : '/sign_in'}`}
                className={`${`${styles.item} ${styles.navItem}`} ${
                  styles.navItem
                }`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.account}
              </NavLink>
              {/* <NavLink to="/my_account/liked" className={`${styles.item} ${styles.navItem}`}>
                                <i className={`${styles.arrow} fas fa-arrow-right`}></i>{words.likedList}
                            </NavLink> */}
              <NavLink
                to={`${isUserVerified ? '/my_account/settings' : '/sign_in'}`}
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.settings}
              </NavLink>
            </div>
            <div className={styles.column}>
              <div className={styles.item}>{words.aboutShop}</div>
              <NavLink
                to="/return"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.return}
              </NavLink>
              <NavLink
                to="/delivery"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.delivery}
              </NavLink>
              <NavLink
                to="/about_us"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.aboutUs}
              </NavLink>
            </div>
            <div className={styles.column}>
              <div className={styles.item}>{words.contacts}</div>
              <NavLink
                to="/contacts"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.contactUs}
              </NavLink>
              <a
                href="mailto:arman.gharibyan1993@gmail.com"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.suggestions}
              </a>
            </div>
            <div className={styles.column}>
              <div className={styles.item}>{words.services}</div>
              <NavLink
                to="/for_authors"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.forAuthors}
              </NavLink>
              <NavLink
                to="/for_publishing_houses"
                className={`${styles.item} ${styles.navItem}`}
              >
                <i className={`${styles.arrow} fas fa-arrow-right`}></i>
                {words.forPublishinghouses}
              </NavLink>
            </div>
          </div>
          <div className={styles.upBtnContainer}>
            <div
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={styles.upBtn}
            >
              <i className="fas fa-chevron-up"></i>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <pre>{words.barcelona} 2021</pre>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => ({
  words: state.main.words,
  // isUserVerified: state.user.isUserVerified,
})

//@ts-ignore
export default connect(mapStateToProps, {})(Footer)
